require('../../../modules/es.array.find');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').find;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/find.js
// module id = 442
// module chunks = 0 1